import { ContractIAImportState, ContractIAImportUnloadState } from '../../states/Contract.IAImport.States';
import * as actions from '../../actions/Contract.IAImport.Actions';

export default function ContractIAImportGetLastReducer(
  state: ContractIAImportState | undefined,
  action: any
): ContractIAImportState {
  const currentState = state ?? ContractIAImportUnloadState;
  switch (action.type) {
    case actions.CONTRACT_IAIMPORT_GETLAST_REQUEST:
      return {
        ...currentState,
        isGettingLastProcess: true,
        successGettingLastProcess: undefined,
        failOnGettingLastProcess: false,
        error: undefined,
      };
    case actions.CONTRACT_IAIMPORT_GETLAST_SUCCESS:
      return {
        ...currentState,
        isGettingLastProcess: false,
        successGettingLastProcess: true,
        failOnGettingLastProcess: false,
        // Puede ser null si no existe ningún proceso previo
        lastProcess: action.process ?? null,
      };
    case actions.CONTRACT_IAIMPORT_GETLAST_FAILURE:
      return {
        ...currentState,
        isGettingLastProcess: false,
        successGettingLastProcess: false,
        failOnGettingLastProcess: true,
        error: action.error,
      };
    default:
      return currentState;
  }
}
